import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod/v3';
import TopicPDFExportPublic from '@/pages/export/topic-pdf-public'

const searchSchema = z.object({
  topicId: z.string().optional(),
  docId: z.string().optional(),
  token: z.string().optional(),
})

export const Route = createFileRoute('/export/topic-pdf/')({
  validateSearch: searchSchema,
  component: TopicPDFExportPublic,
})
